import React, { useEffect } from "react";
import Layout from "../components/Layout";
import PageTitle from "../components/PageTitle";
import { listNepalDescription } from "../redux/actions/aboutNepalAction";
import { useDispatch, useSelector } from "react-redux";

const NepalScreen = () => {
  const dispatch = useDispatch();
  const listNepalDescriptionState = useSelector(
    (state) => state.listNepalDescription
  );
  const { descriptions } = listNepalDescriptionState;
  useEffect(() => {
    dispatch(listNepalDescription());
  }, []);
  return (
    <Layout>
      <PageTitle
        title="Nepal"
        description="Nepal Description"
        button="Edit"
        link={`/edit-nepal/${descriptions && descriptions.uuid}`}
      />
      <div className="card">
        <div class="card-body">
          <div class="card-title mb-4">
            <div
              dangerouslySetInnerHTML={{
                __html: descriptions && descriptions.description,
              }}
            ></div>
          </div>

          {/* <!-- end row --> */}
        </div>
      </div>
    </Layout>
  );
};

export default NepalScreen;
